import React, { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../../utility/Constant";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

function CareerCard({ project, user, handleSingleDelete }) {
  const { aboutUsCareerList, aboutUsCareerListAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };

  return (
    <>
      {visibility ? (
        <div className="group relative border flex flex-col justify-between overflow-hidden shadow-lg rounded-lg h-full bg-white">
          {project ? (
            <div className="p-4 flex flex-col flex-grow gap-3 justify-between">
              {/* Top Section: Metadata */}
              <div>
                <span className="block text-xs md:text-sm font-medium text-gray-700">
                  {project.date}
                </span>
                <span className="block text-sm md:text-base font-medium text-gray-900">
                  {project.subtitle}
                </span>
                <h2 className="text-base md:text-lg font-semibold mb-2">
                  {project.title}
                </h2>
              </div>

              {/* Middle Section: Description */}
              <div className="text-gray-600 break-words">
                <p className="hidden md:block">
                  {showMore
                    ? project.description
                    : `${project.description?.substring(0, 100)}...`}
                </p>
                <p className="block md:hidden">
                  {showMore
                    ? project.description
                    : `${project.description?.substring(0, 50)}...`}
                </p>
              </div>

              {/* Bottom Section: Buttons */}
              <div className="flex items-center justify-between border-t pt-3 mt-3">
                <button
                  onClick={() => setShowMore((old) => !old)}
                  className="text-sm text-red-600 hover:text-[#DB0029]"
                >
                  {project.description.length > 99 &&
                    (showMore ? "Show less" : "Show more")}
                </button>
                <div className="flex gap-2 text-sm md:text-base">
                  <Link
                    to={`/${aboutUsCareerList}/${project._id}`}
                    className="btn btn-outline btn-xs text-blue-500 hover:text-blue-700 transition duration-150 rounded-lg"
                  >
                    <FaRegEdit size={20} />
                  </Link>
                  {user === "admin" && (
                    <button
                      id={project._id}
                      onClick={handleDelete}
                      className="btn btn-outline btn-xs text-red-500 px-3 hover:text-red-700 transition duration-150 rounded-lg"
                    >
                      <MdDeleteForever size={23} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <Link
              to={`/${aboutUsCareerListAdd}`}
              className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full"
            >
              <p className="text-8xl group-hover:text-[#DB0029]">
                <AiFillFileAdd />
              </p>
            </Link>
          )}
        </div>
      ) : null}
    </>
  );
}

export default CareerCard;
